// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Box } from '@mantine/core';
import { useMantineTheme, useMantineColorScheme } from '@mantine/core';
import { Container, Stack } from '@/components/ui/layout';
import { Title, Text, Button, Anchor, Badge } from '@/components/ui/core';
import { TextInput, PasswordInput, Checkbox } from '@/components/ui/inputs';
import { IconMail, IconLock, IconArrowLeft, IconPresentation, IconChartBar, IconUsers, IconRocket } from '@tabler/icons-react';
import { FadeIn } from '@/components/animations';
import { CarouselSlides, SocialLoginButtons } from '../components';

export default function ForgotCarouselOnboarding() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const theme = useMantineTheme();
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === 'dark';

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Login:', { email, password, rememberMe });
  };

  const slides = [
    {
      title: 'Powerful Analytics',
      description: 'Get deep insights into your data with our advanced analytics dashboard and reporting tools.',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=1200&auto=format&fit=crop',
      gradient: { from: theme.colors.indigo[6], to: theme.colors.cyan[5] },
    },
    {
      title: 'Team Collaboration',
      description: 'Work together seamlessly with real-time collaboration features and team workspaces.',
      image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&auto=format&fit=crop',
      gradient: { from: theme.colors.violet[6], to: theme.colors.pink[5] },
    },
    {
      title: 'Lightning Fast',
      description: 'Experience blazing fast performance with our optimized infrastructure and caching.',
      image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=1200&auto=format&fit=crop',
      gradient: { from: theme.colors.orange[6], to: theme.colors.red[5] },
    },
  ];

  return (
    <Box style={{ minHeight: '100vh', display: 'flex' }}>
      {/* Left: Carousel */}
      <Box style={{ width: '50%', display: 'none' }} visibleFrom="md">
        <CarouselSlides slides={slides} autoPlay={true} interval={5000} showDots={true} />
      </Box>

      {/* Right: Form */}
      <Box
        style={{
          flex: 1,
          backgroundColor: isDark ? theme.colors.dark[7] : theme.colors.gray[0],
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2rem',
        }}
      >
        <Container size="xs" w="100%">
          <FadeIn>
            <Stack gap="lg">
              <Button
                component={Link}
                to="/app/demo/auth-pages/forgot-password"
                variant="subtle"
                size="xs"
                leftSection={<IconArrowLeft size={14} />}
                w="fit-content"
              >
                Back to variants
              </Button>

              <Stack gap="xs" align="center">
                <Badge
                  leftSection={<IconPresentation size={12} />}
                  variant="gradient"
                  gradient={{ from: 'orange', to: 'red' }}
                  size="lg"
                >
                  Carousel Onboarding
                </Badge>
                <Title order={2} ta="center" mt="md">
                  Forgot password?
                </Title>
                <Text c="dimmed" size="sm" ta="center">
                  Enter your email to reset your password
                </Text>
              </Stack>

              <form onSubmit={handleSubmit}>
                <Stack gap="md">
                  <TextInput
                    label="Email"
                    placeholder="you@example.com"
                    leftSection={<IconMail size={16} />}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />

                  <PasswordInput
                    label="Password"
                    placeholder="Your password"
                    leftSection={<IconLock size={16} />}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />

                  <Checkbox
                    label="Remember me"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.currentTarget.checked)}
                  />

                  <Button type="submit" fullWidth size="md" variant="gradient" gradient={{ from: 'orange', to: 'red' }}>
                    Sign in
                  </Button>
                </Stack>
              </form>

              <Stack gap="md">
                <Text ta="center" size="sm" c="dimmed">
                  Or continue with
                </Text>
                <SocialLoginButtons providers={['google', 'github']} layout="row" />
              </Stack>

              <Stack gap="xs" align="center">
                <Anchor component={Link} to="/app/demo/auth-pages/forgot-password/carousel-onboarding" size="sm">
                  Forgot your password?
                </Anchor>
                <Text size="sm" c="dimmed">
                  Don't have an account?{' '}
                  <Anchor component={Link} to="/app/demo/auth-pages/register/carousel-onboarding" fw={500}>
                    Sign up
                  </Anchor>
                </Text>
              </Stack>
            </Stack>
          </FadeIn>
        </Container>
      </Box>
    </Box>
  );
}
